import { useFeatureFlagQueryByNameWithAnonymousID } from 'components/layouts/hooks';

// Constants
const FEATURE_FLAGS = {
  TIMEPICKER_TEST: 'test_pdp_timepicker',
  TRACK_AVAILABLE_TIMES: 'track_pdp_available_times_enabled',
} as const;

export const useFeatureFlags = () => {
  const { featureFlag: timepickerTestFlag } = useFeatureFlagQueryByNameWithAnonymousID(FEATURE_FLAGS.TIMEPICKER_TEST);
  const { featureFlag: trackAvailableTimesFlagEnabled } = useFeatureFlagQueryByNameWithAnonymousID(
    FEATURE_FLAGS.TRACK_AVAILABLE_TIMES
  );

  return {
    timepickerTestFlag,
    trackAvailableTimesFlagEnabled,
  };
};
